module.exports = __webpack_public_path__ + "img/customer_design_3.479e4dd.jpg";